import { create } from 'zustand';
import NonConformity from '~/@core/domain/model/rfidReports/NonConformity';
import TablePagination from '~/@core/domain/ui/TablePagination';

interface TransitState {
  transits: NonConformity[];
  transitPagination: TablePagination;
  isLoadingTransit: boolean;
  handleTransitPagination: (newPagination: TablePagination) => void;
  addTransits: (transitsValues: NonConformity[]) => void;
  setIsLoadingTransit: () => void;
}

const useTransitStore = create<TransitState>()(set => ({
  transits: [],
  transitPagination: {
    pageSize: 10,
    current: 1,
    total: 1
  },
  isLoadingTransit: false,
  handleTransitPagination: newPagination =>
    set({ transitPagination: newPagination }),
  addTransits: transitsValues => set({ transits: transitsValues }),
  setIsLoadingTransit: () => {
    set(state => ({ isLoadingTransit: !state.isLoadingTransit }));
  }
}));

export default useTransitStore;
